// Body.js
import React, {useEffect, useState} from 'react';
import './body.css';
import {
  FaEye,
  FaStethoscope,
  FaMicroscope,
  FaHandsHelping,
} from "react-icons/fa";



const testimonials = [

  {
    text:
      "I had been struggling with blurred vision for years. After my consultation and treatment here, I can finally see clearly again. The doctors explained everything patiently and made me feel truly cared for.",
    name: "Mr. Rajith Silva",
    role: "Patient",
  },
  {
    text:
      "As a senior citizen, I was worried about my eye health. The staff treated me with kindness and respect, and the check-up was very thorough. I now feel confident about my vision.",
    name: "Mrs. Kamala Perera",
    role: "Patient",
  },
  {
    text:
      "Their free eye screening program helped many people in our village. Several elders discovered eye conditions early because of this initiative. It has made a real impact in our community.",
    name: "Mr. Sunil Wijesinghe",
    role: "Community Leader",
  },
  {
    text:
      "From the moment I walked in, everything was well-organized and professional. The optometrist took time to answer all my questions, and the service exceeded my expectations.",
    name: "Ms. Nadeesha Fernando",
    role: "Patient",
  },
  {
    text:
      "I brought my child for an eye examination, and the team handled everything so gently and calmly. They made the experience stress-free for both of us.",
    name: "Mrs. Tharanga Jayawardena",
    role: "Parent",
  },
];




function Body() {

//testimonials data
 const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);





  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="lions-badge">Sri Lanka's First Specialised Eye Care Lions Club</div>
            <h1 className="gradient-text">Lions Club<br /> Colombo Eye Care,
              <br />
              District 306 B2
            </h1>
            <p className="hero-description">
              Dedicated to providing accessible, high-quality eye care services to the Colombo community and beyond. Join us in our mission to prevent blindness and restore sight.
            </p>
            <div className="hero-buttons">
              <a href="/aboutus" className="btn-primary">
                 Learn More
                <span>→</span>
              </a>
              {/* <a href="/about" className="btn-secondary">
                Learn More
              </a> */}
            </div>
          </div>
          {/* <div className="hero-image">
            <img 
              src="/lions club   b.png" 
              alt="Eye Care Professional" 
            />
 
          </div> */}
        </div>
      </section>




      {/* Services Section */}
   <section className="services-section">
      <div className="section-header">
        <h2>
          Our <span>Services</span>
        </h2>
        <p>Comprehensive eye care solutions tailored to your needs</p>
      </div>

      <div className="services-grid">
        <div className="service-card">
          <div className="service-icon">
            <FaEye />
          </div>
          <h3>Vision Testing</h3>
          <p>Comprehensive eye examinations using state-of-the-art equipment</p>
        </div>

        <div className="service-card">
          <div className="service-icon">
            <FaStethoscope />
          </div>
          <h3>Medical Eye Care</h3>
          <p>Treatment and management of eye conditions and diseases</p>
        </div>

        <div className="service-card">
          <div className="service-icon">
            <FaMicroscope />
          </div>
          <h3>Advanced Diagnostics</h3>
          <p>Precision diagnostic services for early and accurate detection</p>
        </div>

        <div className="service-card">
          <div className="service-icon">
            <FaHandsHelping />
          </div>
          <h3>Community Outreach</h3>
          <p>Mobile eye care services for underserved and remote areas</p>
        </div>
      </div>
    </section>










      {/* Impact Stats Section */}
      <section className="impact-section">
        <div className="impact-container">
          <div className="impact-item">
            <div className="impact-number">8+</div>
            <div className="impact-label">Years of Service</div>
          </div>
          <div className="impact-item">
            <div className="impact-number">5000+</div>
            <div className="impact-label">Patients Treated</div>
          </div>
          <div className="impact-item">
            <div className="impact-number">100+</div>
            <div className="impact-label">Community Programs</div>
          </div>
          <div className="impact-item">
            <div className="impact-number">15+</div>
            <div className="impact-label">Specialists</div>
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="events-section">
        <div className="section-header">
          <h2>
            Upcoming <span>Events</span>
          </h2>
          <p>Join us in our mission to serve the community</p>
        </div>
        <div className="events-grid">
          <div className="event-card">
            <div className="event-date">March 15, 2024</div>
            <div className="event-content">
              <h3>Free Eye Screening Camp</h3>
              <p>Free vision testing and consultation for seniors</p>
              <div className="event-meta">
                <span>📍 Colombo 03</span>
                <span>⏰ 9:00 AM</span>
              </div>
            </div>
          </div>
          <div className="event-card">
            <div className="event-date">March 22, 2024</div>
            <div className="event-content">
              <h3>Community Awareness Program</h3>
              <p>Education on diabetes and eye health</p>
              <div className="event-meta">
                <span>📍 Community Hall</span>
                <span>⏰ 10:00 AM</span>
              </div>
            </div>
          </div>
          <div className="event-card">
            <div className="event-date">April 5, 2024</div>
            <div className="event-content">
              <h3>Mobile Clinic - Rural Outreach</h3>
              <p>Serving underserved communities</p>
              <div className="event-meta">
                <span>📍 Kalutara</span>
                <span>⏰ 8:00 AM</span>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Testimonials */}
       <section className="testimonials-section">
      <div className="section-header">
        <h2>
          Patient <span>Stories</span>
        </h2>
        <p>Real experiences from people we've helped</p>
      </div>

      <div className="testimonial-carousel">
        <div
          className="testimonial-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {testimonials.map((item, i) => (
            <div className="testimonial-slide" key={i}>
              <div className="testimonial-card">
                <div className="testimonial-quote">“</div>
                <p className="testimonial-text">{item.text}</p>
                <div className="testimonial-author">
                  <div className="author-avatar">👤</div>
                  <div className="author-info">
                    <h4>{item.name}</h4>
                    <p>{item.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="carousel-dots">
        {testimonials.map((_, i) => (
          <span
            key={i}
            className={`dot ${index === i ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>








      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="newsletter-container">
          <h2>Stay Updated</h2>
          <p>Subscribe to our newsletter for health tips and event updates</p>
          <form className="newsletter-form">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              required
            />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Body;